module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Underworld-Awakening.6202080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Underworld-Awakening.jpg
// module id = Um+K
// module chunks = 0